import React, { Component, form, Input } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { inviteUser, generateLink } from 'redux/modules/duck-admin';

import AddRfidForm from './AddRfidForm';
import Title from 'common/forms/FormTitle';
import { Header } from 'common/Header';

class AddRfid extends Component {
  constructor(props) {
    super(props);
    this.state = { text: '' };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({ value: e.target.value });
  }

  handleSubmit(event) {
    alert('A name was submitted: ' + this.state.value);
  }

  render() {
    const { selectedSystem, user, profile, noRfid } = this.props;

    let fullName;
    user ? (fullName = `${user.first_name} ${user.last_name}`) : null;

    return (
      <Header style={{ height: 300 }}>
        {!profile && !noRfid ? (
          <span>
            {user.rfid === 'pending' || !user.rfid ? (
              <span>
                <Title>Add Credential for {fullName}</Title>
                <AddRfidForm
                  userId={user._id}
                  selectedSystem={selectedSystem}
                />{' '}
              </span>
            ) : (
              <span>
                <Title>Edit Credential for {fullName}</Title>{' '}
                <AddRfidForm userEdit={user} selectedSystem={selectedSystem} />{' '}
              </span>
            )}
          </span>
        ) : (
          <span>
            {!noRfid ? (
              <Title>Successfully added the RFID to user!</Title>
            ) : (
              <Title>Successfully removed the RFID from the user!</Title>
            )}
          </span>
        )}
      </Header>
    );
  }
}

function mapStateToProps({ auth, admin, form }) {
  const { owner_systems, selectedSystems, profile, noRfid } = admin;
  return {
    profile,
    owner_systems,
    noRfid,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      inviteUser,
      generateLink,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddRfid);



// WEBPACK FOOTER //
// ./src/Admin/AddRfid.js